import { Injectable } from '@angular/core';
import { HttpBaseService } from './http-base.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})

export class FileUploadService {

  constructor(private http: HttpBaseService, private userService: UserService) { }

  image(imageFile: any) {
    let file = imageFile;
    let userId = this.userService.getSessionUser()._id;

    let fd = new FormData();
    fd.append('fileUpload', file);
    fd.append('documentType', "PROFILE_PICTURE");

    return this.http.post('my/photos', fd);
  }

  clientImage(imageFile: any, options: any) {
    let file = imageFile;
    let firmId = options.firmId;

    let fd = new FormData();
    fd.append('fileUpload', file);
    fd.append('documentType', "CLIENT_LOGO");
    fd.append('firmId', firmId);

    return this.http.post('firms/logo', fd);
  }

  fileUpload(file: any, opts: any, endpoint: string) {

    let fd = new FormData();
    if (file) {
      fd.append('fileUpload', file);
    }

    // iterate over the keys of opts and add them to the FormData
    // keys should have documentType and userTitle
    for(let k in opts){
      fd.append(k, opts[k]);
    }

    return this.http.query('post', endpoint, fd, {
      'ignoreTimeOut': true
    });
  }

  fileUploadMultiple(files: any, opts: any, endpoint: string) {

    let fd = new FormData();
    for (let index = 0; index < files.length; index++) {
        let file = files[index];
        fd.append('fileUpload', file);
    }

    // iterate over the keys of opts and add them to the FormData
    // keys should have documentType and userTitle
    for(let k in opts){
      fd.append(k, opts[k]);
    }

    return this.http.query('post', endpoint, fd, {
      'ignoreTimeOut': true
    });
  }
  
}
